// export { default as truncateHtml } from 'truncate-html';

/*export const truncate = (text: string, count: number) => {
  if (text.length <= count) {
    return text;
  }
  const subString = text.substr(0, count - 1);
  return subString.substr(0, subString.lastIndexOf(' ')) + ' ...';
};*/

export const truncateHtml = (html: string, length: number) => html;
export const truncate = (text: string, count: number) => text;
